<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/Leave_Tomorrow_Behind2#Contents-A">Dedication</a></p>
<p class="Body-Center"><span class="Italic">For all of my readers who asked when they <br/>would get to spend time with Stella again. <br/>I hope you enjoy her new adventure. I sure did.</span></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Leave_Tomorrow_Behind-3.vue?63b189d5